import { UNASSIGNED_ROW_ID } from '@/lib/timeline/constants'
import type { Request } from '@/types/timeline'

/**
 * Whether a timeline request block should use conflict (red) styling.
 * Unassigned requests are never marked conflicting from row overlap alone; only
 * explicit API conflict status applies. Assigned callsign rows may also conflict
 * when two requests overlap on the same resource.
 */
export function shouldShowRequestConflictStyling(
  request: Request,
  rowId: string,
  geometricConflictRequestIds: Set<string>
): boolean {
  if (request.status === 'CONFLICTING') return true
  if (rowId === UNASSIGNED_ROW_ID) return false
  return geometricConflictRequestIds.has(request.id)
}
